import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../features/auth/useAuth';

const FeatureRoute: React.FC<{ feature: string; children: React.ReactNode }> = ({
  feature,
  children,
}) => {
  const { hasFeature, loading } = useAuth();

  // Wait for auth to resolve before deciding — avoids a flash-then-redirect.
  if (loading) {
    return null;
  }

  if (!hasFeature(feature)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default FeatureRoute;
